import {
  Avatar,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import { useState } from "react";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import PersonIcon from "@mui/icons-material/Person";
import { signingOut } from "../../utils/Login";
import { useMsal } from "@azure/msal-react";
import { Config } from "../dialog/config/Config";
import SettingsIcon from "@mui/icons-material/Settings";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useTranslation } from "react-i18next";

const Settings = ({ openLeft }) => {
  const { t } = useTranslation("settings");
  const { instance } = useMsal();
  const [anchorEl, setAnchorEl] = useState(null);
  // eslint-disable-next-line
  const [openConfig, setOpenConfig] = useState(false);
  //const [value, setValue] = useState('1');

  return (
    <>
      <Tooltip
        title={
          <>
            {JSON.parse(sessionStorage.getItem("account"))?.username} <br />{" "}
            {`${JSON.parse(sessionStorage.getItem("account"))?.name} ${
              JSON.parse(sessionStorage.getItem("account"))?.lastname
            }`}
          </>
        }
        placement="right"
      >
        <List sx={{ position: "absolute", bottom: 0, width: "100%" }}>
          <ListItem
            sx={{
              justifyContent: openLeft ? "flex-start" : "center",
              px: openLeft ? 2 : 0,
            }}
            secondaryAction={
              openLeft && (
                <IconButton
                  edge="end"
                  aria-label="delete"
                  sx={{ color: "#fff" }}
                  onClick={(event) => {
                    setAnchorEl(event.currentTarget);
                  }}
                >
                  <MoreVertIcon />
                </IconButton>
              )
            }
          >
            <ListItemAvatar
              sx={{
                cursor: "pointer",
                minWidth: openLeft ? 56 : "auto", // 👈 espacio normal cuando está abierto
                display: "flex",
                justifyContent: openLeft ? "flex-start" : "center",
              }}
            >
              <Avatar
                sx={{
                  bgcolor: "transparent",
                  border: "1px solid rgba(255,255,255,0.3)",
                  color: "#fff",
                }}
              >
                <PersonIcon />
              </Avatar>
            </ListItemAvatar>

            <ListItemText
              sx={{
                display: openLeft ? "block" : "none",
              }}
              primary={
                <Typography
                  sx={{
                    color: "#fff",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    pr: 2,
                  }}
                >
                  {JSON.parse(sessionStorage.getItem("account"))?.username}
                </Typography>
              }
              secondary={
                <Typography
                  sx={{
                    color: "rgba(255,255,255,0.7)",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    pr: 2,
                  }}
                >
                  {`${JSON.parse(sessionStorage.getItem("account"))?.name} ${
                    JSON.parse(sessionStorage.getItem("account"))?.lastname
                  }`}
                </Typography>
              }
            />
          </ListItem>
        </List>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        onClick={() => setAnchorEl(null)}
      >
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setOpenConfig(true);
          }}
        >
          <ListItemIcon>
            <SettingsIcon />
          </ListItemIcon>

          <ListItemText primary={t("settings.menu.settings")} />
        </MenuItem>

        <MenuItem
          onClick={() => {
            switch (JSON.parse(sessionStorage.getItem("account"))?.signin) {
              case "MS_SSO":
                signingOut(instance);
                break;
              default:
                // console.log("signing out");
                sessionStorage.clear();
                localStorage.clear();
                window.location.replace("/signin");
            }
          }}
        >
          <ListItemIcon>
            <ExitToAppIcon color="error" />
          </ListItemIcon>

          <ListItemText
            primary={
              <Typography variant="p" color="error">
                {t("settings.menu.logout")}
              </Typography>
            }
          />
        </MenuItem>
      </Menu>

      <Config open={openConfig} setOpen={setOpenConfig} />
    </>
  );
};

export { Settings };
